<script setup lang="ts">
import IconSelect from '@/components/IconSelect.vue'
import { FormControl, FormDescription, FormField, FormItem, FormMessage } from '@/foundation/form'
import { hexToRgb, RGBToHSL } from '@/utils/utils'
import { assignees, categories, clients, labels, ranges } from '@/views/tickets/data/data'
import AutoFormLabel from './AutoFormLabel.vue'
import type { FieldProps } from './interface'
import { beautifyObjectName } from './utils'

const props = defineProps<FieldProps>()
const dataTypes = [...assignees, ...categories, ...clients, ...labels, ...ranges]

const getLabel = (labelObject: { id: string; name: string; component?: string }) => {
  const dataItem = dataTypes.find((s) => s.value === labelObject?.name)

  return dataItem?.label
}
const getColor = (labelObject: { id: string; name: string; component?: string }) => {
  if (!labelObject?.component) return ''

  const { r, g, b }: { r: number; g: number; b: number } = hexToRgb(labelObject.component) || { r: 255, g: 255, b: 255 }

  return RGBToHSL(r, g, b)
}
</script>

<template>
  <FormField v-slot="slotProps" :name="fieldName">
    <FormItem v-bind="$attrs">
      <AutoFormLabel v-if="!config?.hideLabel" :required="required">
        {{ config?.label || beautifyObjectName(label ?? fieldName) }}
      </AutoFormLabel>
      <FormControl>
        <slot v-bind="slotProps">
          <IconSelect
            :disabled="props.disabled"
            v-bind="props.config?.inputProps"
            :color="getColor(slotProps.componentField.modelValue)"
            :value="slotProps.componentField.modelValue"
            :label="getLabel(slotProps.componentField.modelValue) ?? slotProps.componentField.modelValue?.name"
            @update:value="slotProps.componentField['onUpdate:modelValue']"
          />
        </slot>
      </FormControl>
      <FormDescription v-if="config?.description">
        {{ config.description }}
      </FormDescription>
      <FormMessage />
    </FormItem>
  </FormField>
</template>
